export default {
  camera: { targetFPS: 60, sizeOption: '640 X 480', cameraSelector: '' },
  fpsDisplay: { mode: 'model' },
  backend: '',
  flags: {},
  modelConfig: {
    architecture: 'MobileNetV1',
    outputStride: 16,
    multiplier: 0.75,
    quantBytes: 4,
    visualization: 'binaryMask',
  },
  visualization: {
    foregroundThreshold: 0.5,
    maskOpacity: 1,
    maskBlur: 5,
    pixelCellWidth: 10,
    backgroundBlur: 3,
    edgeBlur: 3,
  },
  isModelChanged: false,
  isFlagChanged: false,
  isVisChanged: false,
  isBackendChanged: false,
  model: 'BodyPix',
};
